import React from 'react';
import AbstractComponent from '../AbstractComponent';
import Footer from '../layout/footer/Footer';
import Form from '../layout/form/Form';
import Input from '../layout/input/Input';
import InputPassword from '../layout/input/InputPassword';
import Alerta from '../layout/alert/Alerta';

import UsuarioService from '../../service/UsuarioService';
import AutenticarService from '../../service/AutenticarService';

import { route, register } from '../../helper/Route';

class Login extends AbstractComponent { 
    constructor(props) {
        super(props);

        this.state = {
            form: {
                usuario: '',
                senha: ''
            },

            erroForm: {
                usuario: '',
                senha: ''
            },

            erro: {
                message: '',
                code: 0
            },

            btnLogin: 'LOGIN'
        }
    }   

    esqueceuSenha() {
        this.props.route(route(
            '',
            'Recuperar Senha',
            'login/recuperar-senha'
        ));
    }    

    onChange(e) {
        let form = this.state.form;

        form[e.target.name] = e.target.value;

        this.setState({form: form});
    }

    limparValidacao() {
        let erroForm = this.state.erroForm;

        erroForm.usuario = '';
        erroForm.senha = '';

        this.setState({erroForm: erroForm});
    }

    validarForm() {
        let form = this.state.form;
        let erroForm = this.state.erroForm;
        let erro = false;

        if(!form.usuario) {
            erroForm.usuario = 'Informe o campo Usuário / Email';
            erro = true;
        }

        if(!form.senha) {
            erroForm.senha = 'Informe o campo Senha';
            erro = true;
        }

        this.setState({erroForm: erroForm});

        return !erro;
    }

    onSubmit() {
        this.setState({btnLogin: 'AGUARDE...'});

        this.limparValidacao();

        if(!this.validarForm()) {
            this.setState({btnLogin: 'LOGIN'});
            this.foco('usuario');
            return ;
        }    

        UsuarioService.logar(            
            this.state.form.usuario,
            this.state.form.senha
        ).then(resposta => {                   
            AutenticarService.logar(resposta.data.token);
        }).catch((erro) => {
            this.setState({btnLogin: 'LOGIN', erro: this.trataErro(erro)});
        });
    }

    render() {
        return(
            <div id="layoutAuthentication">  
                <div id="layoutAuthentication_content">
                    <main>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-5">
                                    <div className="card shadow-lg border-0 rounded-lg mt-5">
                                        <div className="card-header">
                                            <h3 className="text-center font-weight-light my-4">
                                                Login
                                            </h3>
                                        </div>

                                        <div className="card-body">                                             
                                            <Form onSubmit={(e) => this.onSubmit(e)} id="form">              
                                                <Alerta exibir={this.state.erro.code !== 0}
                                                        texto={this.state.erro.message} />

                                                <Input
                                                    md={12}
                                                    xs={12}
                                                    sm={12}
                                                    lg={12}
                                                    id="usuario"
                                                    nome="usuario"     
                                                    defaultFoco={true}                                                  
                                                    value={this.state.form.usuario}
                                                    defaultValue={this.state.form.usuario}
                                                    erro={this.state.erroForm.usuario}                                
                                                    onChange={e => this.onChange(e)}>
                                                    Usuário / Email
                                                </Input>

                                                <InputPassword
                                                    md={12}
                                                    xs={12}
                                                    sm={12}
                                                    lg={12}
                                                    id="senha"
                                                    nome="senha" 
                                                    value={this.state.form.senha}
                                                    defaultValue={this.state.form.senha}
                                                    erro={this.state.erroForm.senha}                                
                                                    onChange={e => this.onChange(e)}>
                                                    Senha
                                                </InputPassword>

                                                {/* <div className="form-group">
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" id="rememberPasswordCheck" type="checkbox" />
                                                        <label className="custom-control-label" for="rememberPasswordCheck">Remember password</label>
                                                    </div>
                                                </div> */}
                                                
                                                <div className="col-md-12                                 
                                                                col-sm-12                                                
                                                                col-lg-12                                                
                                                                col-xs-12
                                                                d-flex
                                                                align-items-center
                                                                justify-content-between 
                                                                mt-4 
                                                                mb-0">
                                                    <a className="small" onClick={(e) => this.esqueceuSenha(e)}>
                                                        Esqueceu a senha?
                                                    </a>

                                                    <button 
                                                        id="btnLogin"
                                                        type="submit"
                                                        className="btn btn-primary"                                                         
                                                        disabled={this.state.btnLogin !== 'LOGIN'}
                                                    >
                                                        {this.state.btnLogin}
                                                    </button>
                                                </div>
                                            </Form>                                                                                      
                                        </div>

                                        <div className="card-footer text-center">
                                            <div className="small">
                                                <a onClick={(e) => this.props.route(
                                                    register(
                                                        '',
                                                        'Registre-se',
                                                        'register'
                                                    )
                                                )}>
                                                    Crie sua conta? Inscreva-se!
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>

                <div id="layoutAuthentication_footer">
                    <Footer />
                </div>
            </div>
        )
    }
}

export default Login;